 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","consolide-theme-consolide-theme-module":"consolide-theme-consolide-theme-module","core-js-js":"core-js-js","default~consolide-main-consolide-main-module~pages-agency-agency-module~pages-aktau-aktau-module~pag~5c12ad9c":"default~consolide-main-consolide-main-module~pages-agency-agency-module~pages-aktau-aktau-module~pag~5c12ad9c","consolide-main-consolide-main-module":"consolide-main-consolide-main-module","default~pages-agency-agency-module~pages-aktau-aktau-module~pages-aktauexpense-aktauexpense-module~p~18365afb":"default~pages-agency-agency-module~pages-aktau-aktau-module~pages-aktauexpense-aktauexpense-module~p~18365afb","pages-usercheck-usercheck-module":"pages-usercheck-usercheck-module","default~pages-agency-agency-module~pages-aktau-aktau-module~pages-aktauexpense-aktauexpense-module~p~44a01405":"default~pages-agency-agency-module~pages-aktau-aktau-module~pages-aktauexpense-aktauexpense-module~p~44a01405","pages-agency-agency-module":"pages-agency-agency-module","pages-avm-avm-module":"pages-avm-avm-module","pages-entrance-entrance-module":"pages-entrance-entrance-module","pages-fb-fb-module":"pages-fb-fb-module","pages-hotels-hotels-module":"pages-hotels-hotels-module","pages-merchandasing-merchandasing-module":"pages-merchandasing-merchandasing-module","pages-ood-ood-module":"pages-ood-ood-module","pages-overview-overview-module":"pages-overview-overview-module","pages-partner-hotels-partner-hotels-module":"pages-partner-hotels-partner-hotels-module","pages-payroll-payroll-module":"pages-payroll-payroll-module","pages-revenue-revenue-module":"pages-revenue-revenue-module","pages-rixos-hotels-rixos-hotels-module":"pages-rixos-hotels-rixos-hotels-module","pages-statistcis-statistcis-module":"pages-statistcis-statistcis-module","pages-tenants-tenants-module":"pages-tenants-tenants-module","pages-wfk-wfk-module":"pages-wfk-wfk-module","pages-aktau-aktau-module":"pages-aktau-aktau-module","pages-aktauexpense-aktauexpense-module":"pages-aktauexpense-aktauexpense-module","pages-aktaufb-aktaufb-module":"pages-aktaufb-aktaufb-module","pages-aktauood-aktauood-module":"pages-aktauood-aktauood-module","pages-aktauoverview-aktauoverview-module":"pages-aktauoverview-aktauoverview-module","pages-aktaupayroll-aktaupayroll-module":"pages-aktaupayroll-aktaupayroll-module","pages-aktaurevenuecalendar-aktaurevenuecalendar-module":"pages-aktaurevenuecalendar-aktaurevenuecalendar-module","pages-aktaurooms-aktaurooms-module":"pages-aktaurooms-aktaurooms-module","pages-avm-home-avm-home-module":"pages-avm-home-avm-home-module","pages-expense-expense-module":"pages-expense-expense-module","pages-hotelnew-hotelnew-module":"pages-hotelnew-hotelnew-module","pages-hotels-demo-hotels-demo-module":"pages-hotels-demo-hotels-demo-module","pages-hotelspremium-hotelspremium-module":"pages-hotelspremium-hotelspremium-module","pages-hotelsthemeking-hotelsthemeking-module":"pages-hotelsthemeking-hotelsthemeking-module","pages-karavansaray-karavansaray-module":"pages-karavansaray-karavansaray-module","pages-karavansarayentrance-karavansarayentrance-module":"pages-karavansarayentrance-karavansarayentrance-module","pages-karavansarayexpense-karavansarayexpense-module":"pages-karavansarayexpense-karavansarayexpense-module","pages-karavansarayfb-karavansarayfb-module":"pages-karavansarayfb-karavansarayfb-module","pages-karavansarayhome-karavansarayhome-module":"pages-karavansarayhome-karavansarayhome-module","pages-karavansarayood-karavansarayood-module":"pages-karavansarayood-karavansarayood-module","pages-karavansarayoverview-karavansarayoverview-module":"pages-karavansarayoverview-karavansarayoverview-module","pages-karavansaraypayroll-karavansaraypayroll-module":"pages-karavansaraypayroll-karavansaraypayroll-module","pages-karavansarayrevenuecalendar-karavansarayrevenuecalendar-module":"pages-karavansarayrevenuecalendar-karavansarayrevenuecalendar-module","pages-karavansarayunits-karavansarayunits-module":"pages-karavansarayunits-karavansarayunits-module","pages-parkpax-parkpax-module":"pages-parkpax-parkpax-module","pages-revenuecalendar-revenuecalendar-module":"pages-revenuecalendar-revenuecalendar-module","pages-shopping-mall-home-shopping-mall-home-module":"pages-shopping-mall-home-shopping-mall-home-module","pages-summary-summary-module":"pages-summary-summary-module","pages-swissotel-swissotel-module":"pages-swissotel-swissotel-module","pages-swissotelexpense-swissotelexpense-module":"pages-swissotelexpense-swissotelexpense-module","pages-swissotelfb-swissotelfb-module":"pages-swissotelfb-swissotelfb-module","pages-swissotelood-swissotelood-module":"pages-swissotelood-swissotelood-module","pages-swissoteloverview-swissoteloverview-module":"pages-swissoteloverview-swissoteloverview-module","pages-swissotelpayroll-swissotelpayroll-module":"pages-swissotelpayroll-swissotelpayroll-module","pages-swissotelrevenuecalendar-swissotelrevenuecalendar-module":"pages-swissotelrevenuecalendar-swissotelrevenuecalendar-module","pages-swissotelrooms-swissotelrooms-module":"pages-swissotelrooms-swissotelrooms-module","pages-tetysblu-tetysblu-module":"pages-tetysblu-tetysblu-module","pages-tetysbluentrance-tetysbluentrance-module":"pages-tetysbluentrance-tetysbluentrance-module","pages-tetysbluexpense-tetysbluexpense-module":"pages-tetysbluexpense-tetysbluexpense-module","pages-tetysblufb-tetysblufb-module":"pages-tetysblufb-tetysblufb-module","pages-tetysbluood-tetysbluood-module":"pages-tetysbluood-tetysbluood-module","pages-tetysbluoverview-tetysbluoverview-module":"pages-tetysbluoverview-tetysbluoverview-module","pages-tetysblupayroll-tetysblupayroll-module":"pages-tetysblupayroll-tetysblupayroll-module","pages-tetysblurevenuecalendar-tetysblurevenuecalendar-module":"pages-tetysblurevenuecalendar-tetysblurevenuecalendar-module","pages-tetysblutenants-tetysblutenants-module":"pages-tetysblutenants-tetysblutenants-module","pages-tlol-detailhc-tlol-detailhc-module":"pages-tlol-detailhc-tlol-detailhc-module","pages-tlol-tlol-module":"pages-tlol-tlol-module","pages-shopping-mall-logo-shopping-mall-logo-module":"pages-shopping-mall-logo-shopping-mall-logo-module","pages-shopping-mall-shopping-mall-module":"pages-shopping-mall-shopping-mall-module","pages-summary-details-summary-details-module":"pages-summary-details-summary-details-module","pages-user-detail-user-detail-module":"pages-user-detail-user-detail-module","pages-login-login-module":"pages-login-login-module","pages-pdfreportkaravansaray-pdfreportkaravansaray-module":"pages-pdfreportkaravansaray-pdfreportkaravansaray-module","pages-pdfreports-pdfreports-module":"pages-pdfreports-pdfreports-module","pages-register-register-module":"pages-register-register-module","pages-shopping-mall-turnover-shopping-mall-turnover-module":"pages-shopping-mall-turnover-shopping-mall-turnover-module","pages-summary-home-summary-home-module":"pages-summary-home-summary-home-module","pages-home-home-module":"pages-home-home-module","pages-aktauhome-aktauhome-module":"pages-aktauhome-aktauhome-module","pages-authorization-authorization-module":"pages-authorization-authorization-module","pages-karavansarayrevenue-karavansarayrevenue-module":"pages-karavansarayrevenue-karavansarayrevenue-module","dom-js":"dom-js","pages-aktaurevenue-aktaurevenue-module":"pages-aktaurevenue-aktaurevenue-module","pages-consolide-reports-consolide-reports-module":"pages-consolide-reports-consolide-reports-module","pages-karavansarayrooms-karavansarayrooms-module":"pages-karavansarayrooms-karavansarayrooms-module","pages-kazakistan-kazakistan-module":"pages-kazakistan-kazakistan-module","pages-main-main-module":"pages-main-main-module","pages-maps-maps-module":"pages-maps-maps-module","pages-pdf-details-pdf-details-module":"pages-pdf-details-pdf-details-module","pages-pdfreports-shopping-details-pdfreports-shopping-details-module":"pages-pdfreports-shopping-details-pdfreports-shopping-details-module","pages-pdfreports-shopping-pdfreports-shopping-module":"pages-pdfreports-shopping-pdfreports-shopping-module","pages-rooms-rooms-module":"pages-rooms-rooms-module","pages-shopping-mall-maps-shopping-mall-maps-module":"pages-shopping-mall-maps-shopping-mall-maps-module","pages-swissotelrevenue-swissotelrevenue-module":"pages-swissotelrevenue-swissotelrevenue-module","pages-tetysblurevenue-tetysblurevenue-module":"pages-tetysblurevenue-tetysblurevenue-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","shadow-css-d7d058ec-d59cb009-js":"shadow-css-d7d058ec-d59cb009-js","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom","swiper-bundle-44a9b1f9-js":"swiper-bundle-44a9b1f9-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
